import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { Invoice, InvoiceStateId, Money as ApiMoney } from 'src/app/api/models';
import { InvoicePaymentStatus } from 'src/app/model/invoice';
import Dinero from 'dinero.js';
import _ from 'lodash';
import { Money } from 'src/app/model/money';

export class CountAndAmount {
  count: number;
  amount: Money;
}

export class InvoicesAndSummary {
  invoices: Invoice[];
  open: CountAndAmount;
  overdue: CountAndAmount;
  paid: CountAndAmount;
}

@Injectable({
  providedIn: 'root'
})
export class InvoiceCalculatorService {

  constructor() { }

  private toDinero(money: Money | ApiMoney): Dinero.Dinero {
    if (!money) {
      return Dinero({ amount: 0, currency: 'EUR' });
    }
    if (money instanceof Money) {
      return money.toDinero();
    }
    return new Money(money).toDinero();
  }

  getInvoicesAndSummary(invoices: Invoice[]): InvoicesAndSummary {
    const filtered = _.orderBy(
      _.filter(invoices, (i) => {
        return _.includes([
          InvoiceStateId.MonitoringEndCustomerPayments,
          InvoiceStateId.WaitingFinalPayment,
          InvoiceStateId.WaitingForReport,
          InvoiceStateId.Completed,
        ], i.state.id)
      }),
      [(i) => dayjs(i.created_at)], ['desc']);

    const summary = this.getSummary(filtered);

    return {
      open: summary.open,
      overdue: summary.overdue,
      paid: summary.paid,
      invoices: filtered,
    }
  }

  getPaymentStatus(invoice: Invoice): InvoicePaymentStatus {
    if (!invoice.total_paid_amount || !invoice.amount) {
      return InvoicePaymentStatus.PAID;
    }

    if (this.toDinero(invoice.total_paid_amount).greaterThanOrEqual(this.toDinero(invoice.amount))) {
      return InvoicePaymentStatus.PAID;
    }

    const now = dayjs();
    if (invoice.due_date && now.isAfter(dayjs(invoice.due_date))) {
      return InvoicePaymentStatus.OVERDUE;
    }
    return InvoicePaymentStatus.OPEN;
  }

  getTotalOpen(invoice: Invoice): Dinero.Dinero {
    //return new Money(invoice.amount).toDinero().subtract(new Money(invoice.total_paid_amount).toDinero())
    // "Eikös se voi olla vaan niin että koko pääoma näkyy asiakkaan limiitillä, kunnes se on kokonaan maksettu?"
    const open = this.toDinero(invoice.amount).subtract(this.toDinero(invoice.total_paid_amount))
    if (open.getAmount() > 0) {
      return this.toDinero(invoice.amount);
    }
    return open;
  }

  getSummary(invoices: Invoice[]) {
    const summary = {
      open: {
        count: 0,
        amount: Dinero({ amount: 0, currency: 'EUR' }),
      },
      overdue: {
        count: 0,
        amount: Dinero({ amount: 0, currency: 'EUR' }),
      },
      paid: {
        count: 0,
        amount: Dinero({ amount: 0, currency: 'EUR' }),
      }
    };
    invoices.forEach((invoice: Invoice) => {
      const status = this.getPaymentStatus(invoice);
      switch (status) {
        case InvoicePaymentStatus.OPEN:
          summary.open.count += 1;
          summary.open.amount = summary.open.amount.add(this.getTotalOpen(invoice));
          break;
        case InvoicePaymentStatus.OVERDUE:
          summary.open.count += 1;
          summary.open.amount = summary.open.amount.add(this.getTotalOpen(invoice));
          summary.overdue.count += 1;
          summary.overdue.amount = summary.overdue.amount.add(this.getTotalOpen(invoice));
          break;
        case InvoicePaymentStatus.PAID:
          summary.paid.count += 1;
          summary.paid.amount = summary.paid.amount.add(this.toDinero(invoice.amount));
          break;
      }
    });

    return {
      open: {
        count: summary.open.count,
        amount: new Money(summary.open.amount),
      },
      overdue: {
        count: summary.overdue.count,
        amount: new Money(summary.overdue.amount),
      },
      paid: {
        count: summary.paid.count,
        amount: new Money(summary.paid.amount),
      }
    };
  }
}
